/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { AutocompleteResponse, PersonDetailsResponse, RemoveFaceTagResponse, ThumbnailResponse } from './customPeopleTagTypes';

export const mockHeroImageResponse: ThumbnailResponse = {
  data: {
    hero_image: 'https://www.heroImage.com',
    tag_name: 'Jane Doe',
  }
};

export const mockFaceId = 'the-face-id';
export const mockCurrentPerson = {
  face_uri: 'https://www.faceImage1.com',
  person_id: mockFaceId,
  tag_name: 'Lydia Williams'
};
export const mockSelectedPerson = {
  face_uri: 'https://www.faceImage2.com',
  person_id: 'person-id-2',
  tag_name: 'Lionel Lee',
};

export const mockAutoCompleteResponse: AutocompleteResponse = {
  data: [
    mockCurrentPerson,
    mockSelectedPerson,
    {
      face_uri: 'https://www.faceImage3.com',
      person_id: 'person-id-3',
      tag_name: 'Tyler Lane',
    }
  ]
};

export const mockPersonDetailsData: PersonDetailsResponse = {
  data: [
    {
      asset_id: 'asset-id-1',
      attachment_id: 'attachment-id-1',
      image_url:
        'https://asset-1.com',
      match_face_id: mockFaceId,
    },
    {
      asset_id: 'asset-id-2',
      attachment_id: 'attachment-id-2',
      image_url:
        'https://asset-2.com',
      match_face_id: mockFaceId,
    },
    {
      asset_id: 'asset-id-3',
      attachment_id: 'attachment-id-3',
      image_url:
        'https://asset-3.com',
      match_face_id: mockFaceId,
    },
    {
      asset_id: 'asset-id-4',
      attachment_id: 'attachment-id-4',
      image_url:
        'https://asset-4.com',
      match_face_id: mockFaceId,
    },
    {
      asset_id: 'asset-id-5',
      attachment_id: 'attachment-id-5',
      image_url:
        'https://asset-5.com',
      match_face_id: mockFaceId,
    },
  ],
  meta: {
    bf_processed: true,
    current_page: 1,
    next_page: 2,
    prev_page: 0,
    total_count: 5,
    total_pages: 1,
  },
};

export const mockRemoveTagResponse: RemoveFaceTagResponse = {
  data: {
    cluster_deleted: false,
    new_person_id: 'new-person-id',
  },
};

export const mockPeoplePageResponse = {
  data: [
    {
      face_label: null,
      image_url: 'https://people-face-1.png',
      person_id: 'face_6zp967s8h3593gtvvr7mm_1322_710',
    },
    {
      face_label: 'John Doe',
      image_url: 'https://people-face-2.png',
      person_id: 'face_xcpv4f5659pxh4sxr58p7vtv_1398_1593',
    }
  ],
  meta: {
    current_page: 1,
    next_page: null,
    prev_page: null,
    total_count: 2,
    total_pages: 1
  }
};

export const mockUpdatePersonTagResponse = {
  data: {
    tag_name: 'Jane Doe'
  }
};

export const temporaryPeopleData = {
  data: [
    [
      { person_id: 'mock_identity_1', face_label: 'Alice Example', image_url: 'https://i.pravatar.cc/300?u=42' },
      { person_id: 'mock_identity_2', face_label: 'Bob Example', image_url: 'https://i.pravatar.cc/300?u=127' },
      { person_id: 'mock_identity_3', face_label: 'Charlie Example', image_url: 'https://i.pravatar.cc/300?u=89' },
      { person_id: 'mock_identity_4', face_label: 'Dana Example', image_url: 'https://i.pravatar.cc/300?u=203' },
      { person_id: 'mock_identity_5', face_label: 'Elliot Example', image_url: 'https://i.pravatar.cc/300?u=156' },
      { person_id: 'mock_identity_6', face_label: 'Finley Example', image_url: 'https://i.pravatar.cc/300?u=78' },
      { person_id: 'mock_identity_7', face_label: '', image_url: 'https://i.pravatar.cc/300?u=234' },
      { person_id: 'mock_identity_8', face_label: '', image_url: 'https://i.pravatar.cc/300?u=91' },
      { person_id: 'mock_identity_9', face_label: 'Indigo Example', image_url: 'https://i.pravatar.cc/300?u=167' },
      { person_id: 'mock_identity_10', face_label: 'Jules Example', image_url: 'https://i.pravatar.cc/300?u=45' },
      { person_id: 'mock_identity_11', face_label: 'Kai Example', image_url: 'https://i.pravatar.cc/300?u=189' },
      { person_id: 'mock_identity_12', face_label: '', image_url: 'https://i.pravatar.cc/300?u=112' },
      { person_id: 'mock_identity_13', face_label: 'Morgan Example', image_url: 'https://i.pravatar.cc/300?u=276' },
      { person_id: 'mock_identity_14', face_label: 'Noel Example', image_url: 'https://i.pravatar.cc/300?u=63' },
      { person_id: 'mock_identity_15', face_label: 'Oakley Example', image_url: 'https://i.pravatar.cc/300?u=198' },
      { person_id: 'mock_identity_16', face_label: 'Parker Example', image_url: 'https://i.pravatar.cc/300?u=134' },
      { person_id: 'mock_identity_17', face_label: 'Quinn Example', image_url: 'https://i.pravatar.cc/300?u=287' }
    ]
  ],
};
